import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import EnumModel from "../../models/enum-list";

export default class EnumRepository extends BaseRepository {
  static modelClass = EnumModel;
  modelName = "enum-list";

  async query({ urlPath }) {
    return await super.query({
      urlPath,
    });
  }

  // This will handle patch requests to dynamic paths
  async patchWithUrl({ urlPath, body }) {
    const newPath = urlPath.includes("/api/") ? urlPath.replace("/api/", "") : urlPath;
    return await super.patch("", body, {
      urlPath: newPath,
    });
  }
}
